/**
 * Vuely Appliction Components
 */
// add nonconformace button
import BcBtnNonconformance from "App_components/Buttons/BcBtnNonconformance";
import BcCalendar from "App_components/Calendar/BcCalendar";
import BcCharts from "App_components/Charts/BcCharts";
// modal email function
import BcModalEmail from "App_components/Modals/BcModalEmail";
// qr button to open modal to scan barcode/qr
import BcScanBarcode from "App_components/Modals/BcScanBarcode";

const ApplicationComponents = {
    install(Vue) {
        Vue.component("bcCharts", BcCharts);
        Vue.component("bcBtnNonconformance", BcBtnNonconformance);
        Vue.component("bcScanBarcode", BcScanBarcode);
        Vue.component("bcCalendar", BcCalendar);
        Vue.component("bcModalEmail", BcModalEmail);
    },
};

export default ApplicationComponents;
